module.exports = __webpack_public_path__ + "img/cailiaofenxi.a9c64afb.png";